/* Mesure des textes du certificat, dans le navigateur : la police Questrial
   reellement chargee, sur un canevas. Une seule mesure sert a l'ecran ET au
   PDF : la composition (retours a la ligne, taille du nom) est donc la meme.
   Crenage desactive des deux cotes (canevas et SVG), comme dans le PDF, qui
   n'en applique pas : sans cela, un texte centre se decalerait d'une fraction
   de millimetre entre l'ecran et le fichier. */

export const FAMILLE = 'Questrial'
const TAILLE_ETALON = 100

let contexte = null

/* Sans canevas (navigateur qui le bloque, banc de test), on ne plante pas
   l'ecran : une mesure approchee (0,5 em par caractere, l'ordre de grandeur
   de Questrial) suffit a composer une page lisible. */
const MESURE_APPROCHEE = (texte, tailleMm) => Array.from(String(texte)).length * 0.5 * tailleMm

export const mesureurCanevas = () => {
  if (!contexte) {
    try {
      contexte = document.createElement('canvas').getContext('2d')
    } catch (e) { contexte = null }
  }
  if (!contexte) return MESURE_APPROCHEE
  return (texte, tailleMm) => {
    contexte.font = `${TAILLE_ETALON}px ${FAMILLE}`
    try { contexte.fontKerning = 'none' } catch (e) { /* navigateur ancien */ }
    return (contexte.measureText(texte).width / TAILLE_ETALON) * tailleMm
  }
}

/* La police doit etre chargee AVANT de mesurer, sinon on mesure la police de
   repli. */
export const policePrete = () => {
  try {
    if (document?.fonts?.load) return document.fonts.load(`${TAILLE_ETALON}px ${FAMILLE}`).then(() => true, () => true)
  } catch (e) { /* rien */ }
  return Promise.resolve(true)
}
